import "./_scrollIndicator.scss";

function ScrollIndicator() {
  return (
    <div className="box">
      <div className="scrolldown">
        <div className="chevrons">
          <div className="chevrondown"></div>
          <div className="chevrondown"></div>
        </div>
      </div>
    </div>
  );
}

export default ScrollIndicator;
